module.exports = __webpack_public_path__ + "img/project-31.60f8281e.png";